// Map a DataForSEO `location_name` to its display currency symbol.
// DFS returns CPC / bid values in the local currency of the queried location,
// so we just need to render the matching symbol — no FX conversion required.
const SYMBOL_BY_HINT = [
  // UK first — most specific match
  { hints: ["united kingdom", "england", "scotland", "wales", "northern ireland", "guernsey", "jersey", "isle of man"], symbol: "£" },
  { hints: ["united states", "usa", "puerto rico"], symbol: "$" },
  // Eurozone members + common European queries
  {
    hints: [
      "ireland", "france", "germany", "spain", "italy", "portugal", "netherlands", "belgium",
      "austria", "finland", "greece", "slovakia", "slovenia", "estonia", "latvia", "lithuania",
      "luxembourg", "malta", "cyprus", "croatia",
    ],
    symbol: "€",
  },
  { hints: ["japan"], symbol: "¥" },
  { hints: ["china"], symbol: "¥" },
  { hints: ["india"], symbol: "₹" },
  { hints: ["australia", "new zealand", "canada", "singapore", "hong kong"], symbol: "$" },
  { hints: ["switzerland"], symbol: "CHF " },
  { hints: ["sweden"], symbol: "kr " },
  { hints: ["norway"], symbol: "kr " },
  { hints: ["denmark"], symbol: "kr " },
  { hints: ["poland"], symbol: "zł " },
  { hints: ["czech"], symbol: "Kč " },
  { hints: ["turkey"], symbol: "₺" },
  { hints: ["mexico", "argentina", "chile", "colombia", "brazil"], symbol: "$" },
  { hints: ["south africa"], symbol: "R " },
  { hints: ["uae", "united arab emirates"], symbol: "AED " },
];

export function currencySymbolForLocation(locationName) {
  const s = (locationName || "").toLowerCase();
  if (!s) return "$";
  for (const row of SYMBOL_BY_HINT) {
    if (row.hints.some((h) => s.includes(h))) return row.symbol;
  }
  return "$";
}

export function formatCpc(value, locationName) {
  if (value == null) return "—";
  const sym = currencySymbolForLocation(locationName);
  return `${sym}${Number(value).toFixed(2)}`;
}
